<script setup lang="ts">
const user = useUser()
const router = useRouter()

function handleCreateClick() {
  if (!user.value)
    return router.push(useGetLoginURL())
}
</script>

<template>
  <div
    h-full w-full
    bg-white
    flex="~ col" gap-5 p-5
    overflow-auto
  >
    <NuxtLink to="/prompt/create">
      <AppButton px="20px" py="10px" w-full @click="handleCreateClick">
        <Heading class="!bg-soft-black !color-white disabled:cursor-not-allowed hover:!color-black hover:!bg-white border-2 border-black" level="5">
          Create/Sell
        </Heading>
      </AppButton>
    </NuxtLink>

    <AppHeaderMenuLinks />
  </div>
</template>

<style lang="scss" scoped>
.header-new-gradient {
  font-weight: bold;
  background: var(--gradient-1, linear-gradient(191deg, #35DBFF 0%, #B09EF8 42.71%, #FD93E7 96.95%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
